import {FCWithHTMLAttributes} from "../types/reactTypes";

const BoxContainer: FCWithHTMLAttributes = ({children}) => {
	return (
		<div className="mb-16 items-stretch bg-gray-100 p-6 shadow-lg last:mb-0">
			{children}
		</div>
	);
};

export default BoxContainer;
